module.exports = __webpack_public_path__ + "static/media/b0_p10_clickable.91283582.png";